import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import dojoQuery from 'dojo/query';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import TaskExecutionView from '../TaskExecution/TaskExecutionView';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import template from './TaskApprovalForm.html?raw';
// NOTE (JS2TS): original define() also listed dead dojo deps (aspect, dom-style, date/locale, number) — dropped.

class TaskApprovalForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityID: any = null;
    jsonEntity: any = null; // Entity wies aus der Datenbank kommt
    isDirty = false;
    _formDataUndirty: any = null;

    errorCallback: any = null;
    successCallback: any = null;

    _isEditor = false;
    _canFinish = false;

    readonly = false;

    maintenanceInfo: any = null;

    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: any = {
    };

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this._expandedItems = [];
        let date = new Date();
        //this.inputWorkingDate.value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "yyyy-MM-dd", timePattern: "", selector: "date" })
    }

    _setReadonlyAttr(value: any): void {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;
        //console.log("setreadonly", value);
    }

    _serializeDataHandle: any = null;
    serializeData_delayed(resetDirtyState?: any, bypassReadonly?: any): void {
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

        this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), 150);
    }

    serializeData(resetDirtyState?: any, bypassReadonly?: any): void {

        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

    }

    startup(bReload?: any): void {
        if (this.entityID != null) {
            this.load();
        }
    }

    _highlightedID: any = null;
    highlight(ID: any): void {
        this._highlightedID = ID;
        this._applyHighlightStyles();
    }

    _applyHighlightStyles(): void {
        if (!this.jsonEntity) return;
        if (!this._highlightedID) return;

        for (let expanderReg of this._expanders) {
            if (expanderReg.ID == this._highlightedID) {
                let element = expanderReg.widget.domNode;
                domClass.add(element, "highlightContainer");
                if (expanderReg.widget.toggleExpand) expanderReg.widget.toggleExpand(true);

                element.scrollIntoView({ behaviour: "smooth" });
            } else {
                let element = expanderReg.widget.domNode;
                domClass.remove(element, "highlightContainer");
            }
        }

    }


    save(callback?: any): void {

        if (this.continuousSaveMode != true) {
            this.StandbyStart();
        }

        console.log("saveData", this.formData);

        var url = window.appRoot + "JDM/SaveXXX";

        this.RequestManager.post(
            url,
            {
                entityID: this.entityID,
                sJsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, this._onSaveResponse, callback),
            lang.hitch(this, this._onSaveError),
            false // sync
        );
    }

    _onSaveResponse(callback: any, response: any): void {

        //console.log("_onSaveResponse", callback, response);


        this.isDirty = false;
        this._formDataUndirty = this.formData;

        this.StandbyStop();

        if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
            callback();
        }
    }

    _onSaveError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }

    loadEntity(entityID: any): void {
        this.entityID = entityID;
        this.load();
    }

    load(): void {

        if (!this.entityID) {
            console.warn("cannot load entity without ID!");
            return;
        }

        this.StandbyStart();

        var url = window.appRoot + "TaskApproval/LoadTask";


        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__LoadTaskEntity",
            { entityID: this.entityID },
            lang.hitch(this, this._onLoadResponse),
            lang.hitch(this, this._onLoadError)
        );
    }

    _onLoadResponse(response: any): void {
        //this.StandbyStop();
        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        console.log("_onLoadResponse", this.jsonEntity);

        if (this.jsonEntity == null || typeof (this.jsonEntity) == "undefined") {
            this.StandbyStop();
            alert("requested item does not exist");
            return;
        }

        this.set("Readonly", this.jsonEntity.isReadonly); // was auch immer gesetzt ist - einmal ausführen (u.a. wegen Eskalationscheckbox)

        this.setFormData();
        //this.inputOccurrenceType._loadListValues();

        this.emit("EntityChange", this.jsonEntity);

        this.StandbyStop();
    }

    _onLoadError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error);
    }

    _expanders: any = [];
    setFormData(): void {
        //console.info("setFormData", this.jsonEntity, this._expandedItems);
        this._expanders = [];

        if ((window as any).taskApprovalSubstitution) {
            this.jsonEntity.substitutionEmployee = (window as any).taskApprovalSubstitution.ID;
            this.hideNode(this.sectionSubstitution, false);
            domAttr.set(this.sectionSubstitution, "innerHTML", this.translations["TaskApproval__SubstitutionActiveMessage"].format((window as any).taskApprovalSubstitution.label));
        }

        let data = this.jsonEntity;

        var inputs: any = dojoQuery("[data-evisattribute]", this.sectionTask);
        for (var i = 0; i < inputs.length; i++) {
            var input = inputs[i];
            var value = this.PitHelper.getEntityAttributeValue(data, input.dataset["evisattribute"], "json");

            if (value) domAttr.set(input, "innerHTML", value);

        }

        this.currentSelectedItems = [];
        this._handleSelectionResult();

        let arrayNames = ["EL_TaskExecutions_open", "EL_TaskExecutions_reviewed", "EL_TaskExecutions_cleared"];
        let targetContainers = [this.executerListContainer_open, this.executerListContainer_reviewed, this.executerListContainer_cleared];

        for (let i = 0; i < arrayNames.length; i++) {

            let array = arrayNames[i];
            let container = targetContainers[i];

            domConstruct.empty(container);


            if (this.jsonEntity[array]?.length) {

                for (let taskExecution of this.jsonEntity[array]) {

                    let label = taskExecution.ref_employee.DispName;

                    if (taskExecution.date) {
                        if (typeof (taskExecution.date) == "string") {

                        }
                    }


                    if (taskExecution.labor_units) {
                        label += " - " + taskExecution.labor_units + "h";
                    }

                    if (taskExecution.date_start) {

                        let execDate = null;
                        if (typeof (taskExecution.date_start) == "string") {
                            execDate = new Date(taskExecution.date_start);
                        } else if (typeof (taskExecution.date_start.getDay) == "function") {
                            execDate = taskExecution.date_start;
                        }

                        label += " " + this.dateToString(execDate, "dd.MM.yyyy");
                    }


                    let expander: any = new ExpandableSection();
                    //expander.setup = function (content, heading, size, expandable, collapsible, expanded, marking)


                    let view = new TaskExecutionView();
                    view.setFormData(taskExecution, i == 0);
                    view.on("change", lang.hitch(this, this._onChangeExecutionView));

                    this._expanders.push({ widget: expander, ID: taskExecution.ID });

                    expander.placeAt(container);
                    expander.setup(view, label, "small", true, true, this._expandedItems.indexOf(taskExecution.ID) != -1);
                    expander.on("expand", lang.hitch(this, this._onExpandItem, taskExecution.ID));
                    expander.on("collapse", lang.hitch(this, this._onCollapseItem, taskExecution.ID));

                    if (taskExecution.is_approval_yes == true) {
                        //expander.setMarking("checked");
                        expander.addIcon("fas fa-thumbs-up w3-text-green", "left");
                    } else if (taskExecution.is_approval_no == true) {
                        expander.addIcon("fas fa-thumbs-down w3-text-red", "left");
                    }

                    if (taskExecution.EL_vt_task_workstep_material_vt_task_executor?.length) {
                        expander.addIcon("fas fa-boxes w3-text-brown", "left");
                    }

                    if (taskExecution.EL_ht_flat_rate_appointment_vt_appointment?.length) {
                        expander.addIcon("fas fa-money-check-alt w3-text-teal", "left");
                    }



                    if (i == 0) {
                        // zu prüfen
                        //expander.setMarking("hasContent");
                        let cb = new CheckBox();
                        //cb.setLabel(taskExecution.ID);
                        cb.setValue(false);
                        cb.on("change", lang.hitch(this, this._onChangeSelectExecution, taskExecution, expander));
                        on(cb.domNode, "click", function (evt: any) { evt.stopPropagation(); }); // tricksen, damit der expander nicht zugeht
                        expander.addRightHeadingContent(cb);

                    } else if (i == 2) {
                        // abgerechnet
                        //expander.addIcon("fas fa-check w3-text-green");
                    } else {
                        // geprüft, nicht abgerechnet
                        //expander.addIcon("fas fa-eye w3-text-blue");
                    }



                    domClass.add(expander.domNode, "w3-margin-top");
                    domAttr.set(expander.domNode, "data-entity-id", taskExecution.ID);
                }
            } else {
                domConstruct.create("span", {
                    "className": "italic secondaryTXT",
                    "innerHTML": this.translations["General__NoEntries"]
                }, container, "only");
            }
        }
        this.serializeData(true); // "nicht dirty" setzen
        this._applyHighlightStyles();
    }

    _onChangeExecutionView(): void {
        this.load();
        this.emit("approvalSaved");
    }

    currentSelectedItems: any = null;
    _onChangeSelectExecution(taskExecution: any, expander: any, state?: any): void {
        if (this.currentSelectedItems == null) this.currentSelectedItems = [];

        let index = this.currentSelectedItems.indexOf(taskExecution.ID);

        if (state === true && index == -1) this.currentSelectedItems.push(taskExecution.ID);
        else if (state === false && index != -1) this.currentSelectedItems.splice(index, 1);

        expander.setMarking(state ? "hasContent" : "default");

        //console.debug("_onChangeSelectExecution", taskExecution, state, this.currentSelectedItems);
        this._handleSelectionResult();
    }

    _handleSelectionResult(): void {
        this.disableNode(this.btnApproveAll, this.jsonEntity?.EL_TaskExecutions_open?.length == 0);
        this.disableNode(this.btnApproveSelected, this.currentSelectedItems.length == 0);
        this.btnApproveSelected.innerHTML = "ausgewählte freigeben ({0})".format(this.currentSelectedItems.length.toString());
    }

    _onClick_ApproveAll(evt: any): void {
        if (this.jsonEntity?.EL_TaskExecutions_open?.length) {
            let dlg = new GenericDialog();

            dlg.show(this.translations["TaskApproval__ApproveBulkConfirmationMessage"].format(this.jsonEntity.EL_TaskExecutions_open.length),
                this.translations["TaskApproval__ApproveBulkConfirmationHeading"],
                null,
                null, //"fas fa-times",
                "yesno",
                lang.hitch(this, this._onConfirmApproveBulkDlg, null));
        }
    }

    _onClick_ApproveSelected(evt: any): void {
        if (this.currentSelectedItems.length) {

            let dlg = new GenericDialog();

            dlg.show(this.translations["TaskApproval__ApproveBulkConfirmationMessage"].format(this.currentSelectedItems.length),
                this.translations["TaskApproval__ApproveBulkConfirmationHeading"],
                null,
                null, //"fas fa-times",
                "yesno",
                lang.hitch(this, this._onConfirmApproveBulkDlg, this.currentSelectedItems));
            //this._saveApprovals(this.currentSelectedItems);
        }
    }

    _onConfirmApproveBulkDlg(selection: any, result: any): void {

        if (result >= 1) {
            this._saveApprovals(selection);
        }
    }

    _saveApprovals(selection: any): void {
        this.StandbyStart();

        let url = window.appRoot + "TaskApproval/SaveApproval";
        this._isRequestActive = true;

        let data: any = {};

        if (selection) {
            data.selection = this.currentSelectedItems;
        }

        data.taskID = this.entityID;

        data.approve = true;

        if (this.jsonEntity.substitutionEmployee) {
            data.substitutionEmployee = this.jsonEntity.substitutionEmployee;
        }

        var stringData = JSON.stringify(data);

        this.StandbyStart();

        this.RequestManager.callfunction(
            (window as any).Webtool_API_TaskApproval__SaveExecutionApproval, // JS2TS: bare undefined identifier in original (missing quotes / leaked global) — preserved
            data,
            lang.hitch(this, this._onSaveApprovalResponse),
            lang.hitch(this, this._onSaveApprovalError)
        );
    }

    _onSaveApprovalResponse(response: any): void {
        this.load();

        this.emit("approvalSaved");
    }

    _onSaveApprovalError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }

    _expandedItems: any = [];
    _onExpandItem(executionID: any): void {
        if (this._expandedItems.indexOf(executionID) == -1) {
            this._expandedItems.push(executionID);
        }
    }

    _onCollapseItem(executionID: any): void {
        let index = this._expandedItems.indexOf(executionID);
        if (index != -1) {
            this._expandedItems.splice(index, 1);
        }
    }

    setEntityIDAttr(entityID: any): void {
        this.entityID = entityID;
    }


    handleErrorResponse(message: any): void {

        if (typeof (message) == "object") message = message.Message;

        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        // ansonsten Fehlermeldung selber irgendwo platzieren?
        else {
            alert(message);
        }
    }

    handleSuccessResponse(): void {
        if (typeof (this.successCallback) == "function") {
            this.successCallback();
            return;
        }
    }
}
TaskApprovalForm.prototype.declaredClass = 'WidgetCollection.JDM.TaskApproval.TaskApprovalForm';

export default mdsWidget(TaskApprovalForm);
